import Vue from 'vue'
import Vuex from 'vuex'

import common from './modules/common'
import company from './modules/company/companyModule'
import policy from './modules/policy'
import product from './modules/product'
import user from './modules/user'

Vue.use(Vuex)

const state = {
  developmentMode: process.env.NODE_ENV === 'development',
}

export const store = {
  root: true,
  modules: {
    common,
    company,
    policy,
    product,
    user,
  },
  state,
}

export default new Vuex.Store(store)
